/**
 * The model's verdict on one project-chat turn (DR-4680): the answer covered the question from the
 * records, covered part of it, or the records or tools lack the data. `unknown` when the follow-up
 * call did not run (partial or errored turn) or failed.
 */
export const AGENT_TURN_COVERAGES = ['answered', 'partial', 'no_data', 'unknown'];
//# sourceMappingURL=agent-turn.schema.js.map